import { createRollbar } from "@estaly/ui";

export const { rollbar, RollbarPlugin } = createRollbar({
  accessToken: process.env.VUE_APP_ROLLBAR_POST_CLIENT_ITEM_ACCESS_TOKEN,
  environment: process.env.VUE_APP_ESTALY_ENV,
});
